module.exports = __webpack_public_path__ + "static/media/jordanmob.132478dc.jpg";